module.exports = __webpack_public_path__ + "img/charity-bean-order-background.5357a11a.png";